import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Card } from "@astryxdesign/core/Card";
import { HStack } from "@astryxdesign/core/Stack";
import { Text, Heading } from "@astryxdesign/core/Text";
import { DropdownMenu } from "@astryxdesign/core/DropdownMenu";
import { useAuth } from "../../contexts/AuthContext";
import { getMonitor360WebUrl } from "../../config/productUrls";
import Navigation from "../Navigation/Navigation";
import ChangePasswordModal from "../ChangePasswordModal/ChangePasswordModal";
import AstryxTheme from "../../theme/AstryxTheme";
import logoAssescont from "../../assets/logo-assescont.png";

export default function Header({ activeTab, setActiveTab }) {
  const { user, logout } = useAuth();
  const [isChangePasswordModalOpen, setIsChangePasswordModalOpen] =
    useState(false);

  const getRoleText = (role) => {
    const roles = {
      admin: "Administrador",
      normal: "Usuário Normal",
      cliente: "Cliente",
    };
    return roles[role] || "Usuário";
  };

  // Itens do menu do usuário (data-driven). Monitor 360 só p/ quem tem acesso.
  const userMenuItems = [
    {
      label: "Perfil",
      icon: <FontAwesomeIcon icon="user-cog" />,
      onClick: () => {
        // TODO: Implementar navegação para perfil
      },
    },
    {
      label: "Configurações",
      icon: <FontAwesomeIcon icon="cog" />,
      onClick: () => setIsChangePasswordModalOpen(true),
    },
    {
      label: "Ajuda",
      icon: <FontAwesomeIcon icon="question-circle" />,
      onClick: () => alert("Ajuda - funcionalidade em desenvolvimento"),
    },
    ...(user?.access_monitor_360 === true
      ? [
          {
            label: "Monitor 360 (nova aba)",
            icon: <FontAwesomeIcon icon="tachometer-alt" />,
            onClick: () =>
              window.open(
                getMonitor360WebUrl(),
                "_blank",
                "noopener,noreferrer",
              ),
          },
        ]
      : []),
    { type: "divider" },
    {
      label: "Sair",
      icon: <FontAwesomeIcon icon="sign-out-alt" />,
      onClick: logout,
    },
  ];

  return (
    <AstryxTheme>
      <Card padding={4}>
        <HStack gap={4} vAlign="center" hAlign="between" wrap="wrap">
          <HStack gap={2} vAlign="center">
            {/* style inline: o preflight do Tailwind aplica img{height:auto},
                que sobrepõe o atributo height="" — inline vence a folha. */}
            <img
              src={logoAssescont}
              alt="Assescont"
              style={{ height: 28, width: "auto" }}
            />
            <Heading level={1}>HubNFSE</Heading>
          </HStack>

          <Navigation
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            userRole={user?.role}
            monitor360Href={
              user?.access_monitor_360 === true ? getMonitor360WebUrl() : null
            }
          />

          <HStack gap={2} vAlign="center">
            <Text type="supporting">{getRoleText(user?.role)}</Text>
            <DropdownMenu
              button={{
                label: user?.name || "Usuário",
                variant: "ghost",
                icon: <FontAwesomeIcon icon="user" />,
              }}
              items={userMenuItems}
              hasChevron
              placement="below"
              menuWidth={240}
            />
          </HStack>
        </HStack>
      </Card>

      {/* Change Password Modal */}
      <ChangePasswordModal
        isOpen={isChangePasswordModalOpen}
        onClose={() => setIsChangePasswordModalOpen(false)}
      />
    </AstryxTheme>
  );
}
